
function runYouTubePlayers() {
    const youtubePlayers = document.querySelectorAll('.video__player--youtube');
    
    if (youtubePlayers.length > 0) {
        youtubePlayers.forEach( (element) => {
            
            let youTubePlayer = element.querySelector('.video__player');
            const playerId = youTubePlayer.id;
            const videoId  = youTubePlayer.dataset.source;
            
            window.YT.ready(function() {
                youTubePlayer = new YT.Player(playerId, {
                        height: '550',
                        width: '972',
                        videoId: videoId,
                        playerVars: {
                            'showinfo': 0,
                            'playsinline': 1,
                            'controls' : 1,
                            'rel' : 0, //still active but only from this youtube channel,
                            'modestbranding': 1,
                            'fs': 0,
                            'iv_load_policy': 3
                        },
                    events: {
                        'onReady': onPlayerReady
                    }
                })
            });

            function onPlayerReady(event) {
                const player = event.target;
                player.setVolume(25);
            }
        })
    }
}


function onYouTubeIframeAPIReady() {
    runYouTubePlayers();
}

onYouTubeIframeAPIReady();